import React, { useEffect, useRef } from 'react'
import { Target, Eye, Heart, Users, Award, Calendar, CheckCircle } from 'lucide-react'
import './AboutUs.css'

// ── PHOTO SLIDESHOW ──────────────────────────────────────────────
// Add more slides by duplicating any { src, caption } line below.
const slides = [
  { src: '/media/image0.jpeg', caption: 'Founder of MSS' },
  { src: '/media/image1.jpg', caption: 'Working with MSS — Gurumas and Gurujis.' },
  { src: '/media/image6.jpeg', caption: 'Together they help countless number of student to achive their success in carrier.' },
  { src: '/media/image2.jpg', caption: 'Teachers Training — At MSS head office.' },
  { src: '/media/image3.jpg', caption: 'MSS New Facility —For the Student.' },
  { src: '/media/image4.jpg', caption: 'Students at MSS -राष्ट्र निर्माण की प्रक्रिया व्यक्ति के आंतरिक विकास, अनुशासन और समर्पण से शुरू होती है।.' },
  { src: '/media/image5.jpeg', caption: 'Founding Members - Serving Nation from last 30 years ' }
]

function PhotoSlideshow() {
  const [cur, setCur] = React.useState(0)
  const timerRef = React.useRef(null)

  const goTo = (idx) => {
    setCur(idx)
    clearInterval(timerRef.current)
    timerRef.current = setInterval(() => setCur(c => (c + 1) % slides.length), 5000)
  }

  React.useEffect(() => {
    timerRef.current = setInterval(() => setCur(c => (c + 1) % slides.length), 5000)
    return () => clearInterval(timerRef.current)
  }, [])

  return (
    <div className="about-slideshow">
      <div className="about-slideshow__viewport">
        {slides.map((slide, i) => (
          <div key={i} className={`about-slideshow__slide${i === cur ? ' active' : ''}`}>
            <img src={slide.src} alt={slide.caption} loading="lazy"/>
            <div className="about-slideshow__caption">{slide.caption}</div>
          </div>
        ))}
        <div className="about-slideshow__dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`about-slideshow__dot${i === cur ? ' active' : ''}`}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
        <div className="about-slideshow__progress" key={cur}>
          <div className="about-slideshow__progress-bar"/>
        </div>
      </div>
    </div>
  )
}
// ── END PHOTO SLIDESHOW ──────────────────────────────────────────


const team = [
   { name: 'Mr. Harish Chandra Parida', role: 'President/Co-Founder', initials: 'HP' },
  { name: 'Mr. Rabindra Nath Ray', role: 'Founder', initials: 'RR' },
  { name: 'Mr. Mahendra Nath Ray', role: 'Secretary', initials: 'MR' },
  { name: 'Mr. Ratikant Mahant', role: 'Treasurer', initials: 'RM' },
  { name: 'Mr. Ajay Kumar Nayak', role: 'HOD- MSS Teachers Academy', initials: 'AN' },
  { name: 'Miss. Rinku Mandal', role: 'Programe Director- MSS Teachers Academy', initials: 'RM' },
  { name: 'Mr. Kartik Nayak', role: 'JE Field Coordinator', initials: 'KN' },
  { name: 'Mr. Chittaranjan Nayak', role: 'Programe Manager- MSS Teachers Academy', initials: 'CN' },
]

const milestones = [
  { year: '2000', event: 'Samiti founded with 10 children in a single-room school.' },
  { year: '2005', event: 'First hostel facility opened; 50 children enrolled.' },
  { year: '2006', event: 'Skill development centre launched with tailoring & computer training.' },
  { year: '2010', event: 'Partnership with district education department; reach extends to 48 villages.' },
  { year: '2015', event: 'New hostel block accommodating 120 children inaugurated.' },
  { year: '2025', event: '500th child milestone; 45 villages covered with 6 active programs.' },
]

const values = [
  { icon: Heart, title: 'Compassion', desc: 'Every decision is rooted in genuine care for the children and families we serve.' },
  { icon: CheckCircle, title: 'Integrity', desc: 'Full transparency in fund utilisation; annual reports published for public scrutiny.' },
  { icon: Users, title: 'Inclusion', desc: 'All tribal children below poverty line are welcome regardless of caste or religion.' },
  { icon: Award, title: 'Excellence', desc: 'High-quality education and training guided by outcome-focused programming.' },
]

function Reveal({ children, className }) {
  const ref = useRef(null)
  useEffect(() => {
    const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) { ref.current.classList.add('visible'); o.disconnect() } }, { threshold: 0.12 })
    if (ref.current) o.observe(ref.current)
    return () => o.disconnect()
  }, [])
  return <div ref={ref} className={`reveal-el ${className || ''}`}>{children}</div>
}

export default function AboutUs() {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero__bg"/>
        <div className="container about-hero__content">
          <span className="section-tag">Who We Are</span>
          <h1 className="section-title" style={{color:'var(--sky-900)'}}>About Malyabanta<br/>Swechhasevi Samiti</h1>
          <p className="section-desc" style={{margin:'0 auto'}}>
            A volunteer-driven non-profit dedicated since 2000 to ensuring that no tribal child in rural Odisha is denied the light of education due to poverty.
          </p>
        </div>
      </section>

      {/* Photo Slideshow */}
      <section className="page-section" style={{background:'var(--sky-50)'}}>
        <div className="container">
          <div className="text-center" style={{marginBottom:'32px'}}>
            <span className="section-tag">Our Moments</span>
            <h2 className="section-title">Life at MSS</h2>
          </div>
          <PhotoSlideshow />
        </div>
      </section>
      

      {/* Mission & Vision */}
      <section className="page-section">
        <div className="container">
          <div className="mv-grid">
            <Reveal>
              <div className="mv-card mv-card--mission card">
                <div className="mv-card__icon"><Target size={28}/></div>
                <h2 className="mv-card__title">Our Mission</h2>
                <p className="mv-card__text">
                  To provide free, quality education, skill training, nutritious meals, and safe residential facilities to below-poverty-line tribal children — removing every barrier that stands between a child and their future.
                </p>
              </div>
            </Reveal>
            <Reveal>
              <div className="mv-card mv-card--vision card">
                <div className="mv-card__icon"><Eye size={28}/></div>
                <h2 className="mv-card__title">Our Vision</h2>
                <p className="mv-card__text">
                  A world where every tribal child in Odisha grows up educated, skilled, and empowered — capable of breaking the intergenerational cycle of poverty and contributing meaningfully to society.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>


      {/* Our Story */}
      <section className="page-section story-section">
        <div className="container">
          <div className="story-grid">
            <Reveal className="story-text">
              <span className="section-tag">Our Story</span>
              <h2 className="section-title" style={{textAlign:'left'}}>How It All Began</h2>
              <p style={{color:'var(--gray-600)', lineHeight:'1.8', marginBottom:'16px'}}>
                In 2000, a small group of local volunteers in Malyabanta village noticed that dozens of tribal children were dropping out of school simply because they couldn't afford books, uniforms, or the long walk to the nearest school. 
              </p>
              <p style={{color:'var(--gray-600)', lineHeight:'1.8', marginBottom:'16px'}}>
                They pooled their own savings, borrowed a single room, and started teaching 30 children. Word spread. More children came. Parents in remote hamlets heard there was a place that genuinely cared.
              </p>
              <p style={{color:'var(--gray-600)', lineHeight:'1.8'}}>
                Today, Malyabanta Swechhasevi Samiti runs free education, hostel facilities, skill development workshops, and tuition centres — all at zero cost — serving over 500 children across 60 villages.
              </p>
            </Reveal>
            <Reveal className="story-milestones">
              <h3 className="story-milestones__title">Our Journey</h3>
              <div className="timeline">
                {milestones.map((m, i) => (
                  <div key={m.year} className="timeline__item">
                    <div className="timeline__dot"/>
                    <div className="timeline__content">
                      <span className="timeline__year">{m.year}</span>
                      <p className="timeline__event">{m.event}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="page-section values-section">
        <div className="container">
          <Reveal className="text-center">
            <span className="section-tag">What Drives Us</span>
            <h2 className="section-title">Our Core Values</h2>
          </Reveal>
          <div className="values-grid">
            {values.map(v => (
              <Reveal key={v.title}>
                <div className="value-card card">
                  <div className="value-card__icon"><v.icon size={24}/></div>
                  <h3 className="value-card__title">{v.title}</h3>
                  <p className="value-card__desc">{v.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="page-section team-section">
        <div className="container">
          <Reveal className="text-center">
            <span className="section-tag">The People Behind It All</span>
            <h2 className="section-title">Our Leadership Team</h2>
          </Reveal>
          <div className="team-grid">
            {team.map(member => (
              <Reveal key={member.name}>
                <div className="team-card card">
                  <div className="team-card__avatar">{member.initials}</div>
                  <h3 className="team-card__name">{member.name}</h3>
                  <p className="team-card__role">{member.role}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
